<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{modalTitle}} {{getTitleStringType()}}</div>
        <div class="modal-body">
            <form [formGroup]="formGroup" class="form-card-content" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <div class="infos-units">
                    <div class="inline">
                        <frg-form-input label="Détail de la prescription" id="detail" type="textarea" [formGroup]="formGroup"
                            [control]="formGroup.get('detail')">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input *ngIf="typeActe == typesActes.BIO" label="Nombre de renouvellements" id="nb_renouvellement" type="fake-int-number" minNumber="0" [formGroup]="formGroup"
                            [control]="formGroup.get('nb_renouvellement')">
                        </frg-form-input>
                        <frg-form-input *ngIf="typeActe == typesActes.BIO" label="Fréquence de renouvellement" id="freq_renouvellement" type="fake-int-number" minNumber="0" [formGroup]="formGroup"
                            [control]="formGroup.get('freq_renouvellement')">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input label="En rapport avec une ALD" id="ald" isCheckLabelAlign="true" type="checkbox" [formGroup]="formGroup"
                            [control]="formGroup.get('ald')" [disabled]="formGroup.get('ald').disabled">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input label="En rapport avec un accident du travail ou une maladie professionnelle" id="ald" isCheckLabelAlign="true" type="checkbox" [formGroup]="formGroup"
                            [control]="formGroup.get('professionnel')" [disabled]="formGroup.get('professionnel').disabled">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input label="En rapport avec la prévention" id="prevention" isCheckLabelAlign="true" type="checkbox" [formGroup]="formGroup"
                            [control]="formGroup.get('prevention')" [disabled]="formGroup.get('prevention').disabled">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input label="Non remboursable" id="ald" type="checkbox" isCheckLabelAlign="true" [formGroup]="formGroup"
                            [control]="formGroup.get('non_remboursable')" [disabled]="formGroup.get('non_remboursable').disabled">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input label="Hors nomenclature" id="hors_nomenclature" isCheckLabelAlign="true" type="checkbox" [formGroup]="formGroup"
                            [control]="formGroup.get('hors_nomenclature')" [disabled]="formGroup.get('hors_nomenclature').disabled">
                        </frg-form-input>
                    </div>
                    <div class="inline" *ngIf="typeActe == typesActes.BIO">
                        <frg-form-input label="À jeun" id="ajeun" type="checkbox" isCheckLabelAlign="true" [formGroup]="formGroup"
                            [control]="formGroup.get('ajeun')" [disabled]="formGroup.get('ajeun').disabled">
                        </frg-form-input>
                    </div>
                    <div class="inline">
                        <frg-form-input label="Données à caractère médical" id="donnees_medicales" type="textarea" [formGroup]="formGroup"
                          [control]="formGroup.get('donnees_medicales')">
                        </frg-form-input>
                        <div class="info_donnees_medicales">
                          Donnée permettant au prescripteur de renseigner des éléments cliniques pertinents avec l'acte.<br/><br/>
                          Elles ne sont visibles ni du patient ni de l'Assurance Maladie.
                        </div>
                    </div>
                </div>
                <div class="button-wrapper">
                    <frg-button (activated)="closeAddActeModal()" [backgroundColor]="'var(--darkest-primary)'">
                        Annuler
                    </frg-button>
                    <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">
                        {{ currentActe ? "Modifier" : "Ajouter"}}</frg-button>
                </div>
                <div class="error-container group-error" [ngClass]="{'no-height': !isError}">
                    {{errorMessage}}
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>
